import { useOutletContext } from 'react-router-dom';
import { ClientGiftIdeas } from '../ClientGiftIdeas';

interface ClientData {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  phone?: string;
  email_verified: boolean;
  last_login?: string;
  created_at: string;
}

interface ContextData {
  client: ClientData;
  cachedData: Record<string, any>;
  handleDataLoaded: (tabName: string, data: any) => void;
}

export function GiftIdeasTab() {
  const { cachedData, handleDataLoaded } = useOutletContext<ContextData>();

  return (
    <ClientGiftIdeas 
      cachedData={cachedData.events}
      onDataLoaded={(data) => handleDataLoaded('events', data)}
    />
  );
}